import { createSlice } from '@reduxjs/toolkit';

import { ProductManagementInitialState } from './initialState';

const initialState = ProductManagementInitialState;

const ProductManagementSlice = createSlice({
  name: 'ProductManagement',
  initialState,
  reducers: {
    setProcessLoading: (state, action) => {
      state.processingStatus.loading = action.payload;
    },
    setProcessError: (state, action) => {
      state.processingStatus.error = action.payload;
    },
    setGetProductOption: (state, action) => {
      state.fetchProductOptions.GetProductOptions = action.payload;
    },
    setIsLoadProductOptionsSuccess: (state, action) => {
      state.fetchProductOptions.isLoadProductOptionsSuccess = action.payload;
    },
  },
});

export const {
  setProcessLoading,
  setProcessError,
  setGetProductOption,
  setIsLoadProductOptionsSuccess,
} = ProductManagementSlice.actions;

export default ProductManagementSlice.reducer;
